import { Component } from "react";
import { withToastManager } from "react-toast-notifications";
import ToastDemo from "../Helper/toaster";
import { invalidateAuthConfigCache } from "../../auth/authConfigService";
import { clearStudioCapabilitiesCache } from "../Helper/studioCapabilities";
import api from "../../Environment";

import { translate } from "react-multi-lang";

class Logout extends Component {
  componentDidMount() {
    this.performLogout();
  }

  clearLocalAuth = () => {
    [
      "accessToken",
      "userId",
      "userLoginStatus",
      "push_status",
      "active_profile_id",
      "userType",
      "username",
      "active_profile_image",
      "active_profile_name",
    ].forEach(function (key) {
      localStorage.removeItem(key);
    });
    invalidateAuthConfigCache();
    clearStudioCapabilitiesCache();
  };

  finishLogout = () => {
    this.clearLocalAuth();
    this.props.history.push("/login");
    ToastDemo(
      this.props.toastManager,
      this.props.t("logout_success"),
      "success"
    );
  };

  /**
   * Invalidate the server session token before clearing local auth.
   * Environment.postMethod attaches id + token from localStorage, so the
   * API call must complete (or fail) before local keys are removed.
   */
  performLogout = async () => {
    const userId = localStorage.getItem("userId");
    const accessToken = localStorage.getItem("accessToken");

    try {
      if (userId && accessToken) {
        await api.postMethod("logout", {});
      }
    } catch (error) {
      // Local logout must proceed even if the network/API call fails.
    } finally {
      this.finishLogout();
    }
  };

  render() {
    return null;
  }
}

export default withToastManager(translate(Logout));
